import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=54df694c&"
import script from "./Stages.vue?vue&type=script&lang=ts&"
export * from "./Stages.vue?vue&type=script&lang=ts&"
import style0 from "./Stages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports